<template>
  <div class="testing-wizard">
    <McWizard :items="computedItems" :activeKey="activeKey" :withNumber="withNumber" />
  </div>
</template>

<script>
import McWizard from '@/components/McWizard'

export default {
  components: {
    McWizard,
  },
  props: {
    activeKey: {
      type: String,
      default: 'step_1',
    },
    withNumber: {
      type: Boolean,
      default: true,
    },
    withSubLabel: {
      type: Boolean,
      default: false,
    },
    withSubSubLabel: {
      type: Boolean,
      default: false,
    },
  },  
  data() {
    return {
      items: [
        {
          key: 'step_1',
          label: 'Step text',
        },
        {
          key: 'step_2',
          label: 'Step text',
        },
        {
          key: 'step_3',
          label: 'Step text',
        },
      ],
    }
  },
  computed: {
    computedItems() {
      const items = [...this.items]
      if (this.withSubLabel) {
        items.forEach((item, idx) => {
          items[idx] =  {
            ...item,
            sub_label: 'Sub-step 1'
          }
        })
      }

      if (this.withSubSubLabel) {
        items.forEach((item, idx) => {
          items[idx] =  {
            ...item,
            subsub__label: 'Sub-step 2'
          }
        })
      }
      
      return items
    }
  }
}
</script>

<style lang="scss" scoped>
.testing-wizard {
  width: 100%;
}
</style>